import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthStore } from '@app/stores/auth.store';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// Blocks navigation while a not-qualified legal entity is selected.
// If triggered, logs out from the company and routes back to the natural profile.
export const notQualifiedCompanyGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const modalService = inject(NgbModal);

  const company = authStore.loggedInCompany();

  if (company && company.stepInvestorQualification !== true) {
    // Close any open modals first, then log out from company and redirect.
    modalService.dismissAll();
    authStore.logoutAsCompany().subscribe(() => {
      router.navigate(['/profile', 'natural']);
    });
    return false;
  }

  return true;
};

